package one.healthium.url_provider.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class UrlItemDto(
    @SerialName("title") val title: String,
    @SerialName("url") val url: String,
    @SerialName("type") val type: String,
)
